export default __webpack_public_path__ + "static/media/Cloud-PT.24f529de.jpg";